// extracted by mini-css-extract-plugin
export default {"alertContainer":"CustomAlert_alertContainer__m8o7M"};